import { useTranslation } from 'react-i18next';

import * as Styled from './TechnicalBreak.styles';

const TechnicalBreak = () => {
  const { t } = useTranslation();
  return (
    <Styled.Container>
      <Styled.BuildIcon />
      <Styled.Title level={4} padding="0.75rem 0 0 0">
        {t('technicalBreak.title')}
      </Styled.Title>
      <p>{t('technicalBreak.description')}</p>
      <p>{t('technicalBreak.availability')}</p>
    </Styled.Container>
  );
};

export default TechnicalBreak;
